import { inject, Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { PolicyChangeRequestType } from '@amfam/shared/models/lib/policy/policy-change.model';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';
import { CopyService } from '@amfam/shared/utility/shared-services/lib/copy/copy.service';

@Injectable({
  providedIn: 'root'
})
export class PolicyTransmuteService {
  private copyService = inject(CopyService);
  private feature = inject(FeatureFlagService);

  public getChangeRequestTypeText(
    policyChangeType: PolicyChangeRequestType | null | undefined
  ): string | undefined {
    const isNewTemplate = this.feature.isEnabled('request_change_new_template');
    // Extract the name from the Dictionary object.
    const copyObj = this.copyService.getCopy(
      isNewTemplate ? 'policy.requestTypes' : 'policy.requestType'
    );
    return Object.keys(copyObj).find(k => copyObj[k] === policyChangeType);
  }

  public initializeFormControls(groupName: UntypedFormGroup): (AbstractControl | undefined)[] {
    const formControlsArr: (AbstractControl | undefined)[] = [];
    Object.keys(groupName.controls).forEach(controlName => {
      formControlsArr.push(this.buildFormControl(groupName, controlName));
    });
    return formControlsArr;
  }

  private buildFormControl(
    groupName: UntypedFormGroup,
    controlName: string
  ): AbstractControl | undefined {
    return groupName.controls[controlName];
  }
}
